import { Injectable } from '@angular/core';
import { cloneDeep, isArray } from 'lodash';
import { SclSearchClientConstantService } from '@formbird/services';

@Injectable({
  providedIn: 'root'
})
export class RelatedDocumentQueries {

  constructor() {
  }

  processElasticQuery(self, text, isOnClick?) {
    const vm = self;

    if (vm.componentDefinition.filter) {
      const filter = vm.processHandlebars(vm.componentDefinition.filter);

      if (typeof filter === 'string') {
        vm.options.filter = JSON.parse(filter.replace(/'/g, '"'));
      } else {
        vm.options.filter = filter;
      }

      if (vm.options.filter.query.bool.should === undefined) {
        vm.options.filter.query.bool.should = [];
      }
      if (vm.options.filter.query.bool.must instanceof Object && vm.options.filter.query.bool.must.constructor === Object) {
        const objMust = vm.options.filter.query.bool.must;
        vm.options.filter.query.bool.must = [];
        vm.options.filter.query.bool.must.push(objMust);
      } else {
        if (vm.options.filter.query.bool.must === undefined) {
          vm.options.filter.query.bool.must = [];
        }
      }
      if (!isOnClick) {
        // Add wildcard to query filter 'systemHeader.summaryName'
        if (text) {
          vm.options.filter.query.bool.must = vm.getObjectNotWildcardSummaryName(vm.options.filter.query.bool.must);
          vm.options.filter.query.bool.must.push({ wildcard: { 'systemHeader.summaryName.lcase': '*' + text.toLowerCase() + '*' } });
        }
      } else {
        if (vm.componentDefinition.uniqueSelection) {
          if (vm.options.filter.query.bool.must_not === undefined) {
            vm.options.filter.query.bool.must_not = [];
          }
          if ((vm.document[vm.componentDefinition.name] && vm.document[vm.componentDefinition.name].length >= 1)) {
            const resultData = cloneDeep(vm.document[vm.componentDefinition.name]);
            resultData.map(doc => {
              if (doc.documentId) {
                vm.options.filter.query.bool.must_not.push({term: {documentId: doc.documentId}});
              }
              if (doc._source) {
                if (doc._source.documentId) {
                  vm.options.filter.query.bool.must_not.push({term: {documentId: doc._source.documentId}});
                }
              }
            });
          }
        }
      }

    }
  }

  processDexieQuery(self, text, isOnClick) {
      const vm = self;
      if (!vm.options.filter) {
        vm.options.filter = {};
      }

      if (!isOnClick) {
        // Add wildcard to query filter 'systemHeader.summaryName'
        if (text) {
          const query = isArray(vm.options.filter.dexieQuery) ? vm.options.filter.dexieQuery : [];
          let i;
          let isFound = false;
          for (i = 0; i < query.length; i++) {
            if (query[i].field ===  'systemHeader.summaryName') {
              query[i].value = text.toLowerCase();
              query[i].operator = SclSearchClientConstantService.operator.contains;
              isFound = true;
              break;
            }
          }
          if (!isFound) {
            query.push({ field: 'systemHeader.summaryName', value: text.toLowerCase(),
              operator: SclSearchClientConstantService.operator.contains});
          }
          vm.options.filter.dexieQuery = query;
        }
      } else {
        if (vm.componentDefinition.uniqueSelection) {
          vm.options.filter.dexieQuery = !isArray(vm.options.filter.dexieQuery) ? [] : vm.options.filter.dexieQuery;
          if ((vm.document[vm.componentDefinition.name] && vm.document[vm.componentDefinition.name].length >= 1)) {
            const resultData = cloneDeep(vm.document[vm.componentDefinition.name]);
            resultData.map(doc => {
              if (doc.documentId) {
                vm.options.filter.dexieQuery.push({ field: 'documentId', value:  doc.documentId,
                  operator: SclSearchClientConstantService.operator.notEquals});
              }
              if (doc._source) {
                if (doc._source.documentId) {
                  vm.options.filter.dexieQuery.push({ field: 'documentId', value: doc._source.documentId,
                    operator: SclSearchClientConstantService.operator.notEquals});
                }
              }
            });
          }
        }
      }

  }



}

